import React, { useEffect } from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { AuthSignup, authService } from "@unisearch/auth";
import { useRouter } from "next/router";
import { swalError, capitalizeFirstLetter } from "@unisearch/helpers";

const Signup = () => {
  const router = useRouter();
  const profileInfo = authService.getProfileData();

  if (profileInfo && profileInfo.userTypeSlug) {
    router.push(`/app/${profileInfo.userTypeSlug}`);

    return false;
  }

  return (
    <LayoutMain
      title="Signup Student"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/signup-student`}
    >
      <AuthSignup userTypeSlug="student" />
    </LayoutMain>
  );
};

export default Signup;
